import Actions from "../action";

const initialState = {
    isLoading: false,
    toggle: undefined,
    error: false
}
const ToggleReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case Actions.TOGGLE: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.TOGGLE_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                toggle: action.data,
                error: false
            };
        }
        case Actions.TOGGLE_FAILURE: {
            return {
                ...state,
                isLoading: false,
                toggle: undefined,
                error: true,
            };
        }
        default:
            return state;
    }
};
export default ToggleReducer;